<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="年度" name="fiscalYearMonth">
                <YearPicker style="width: 100%" v-model:value="searchForm.year" :format="dateFormat.DATE_YEAR"
                    :showTime="false" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined />
                </template>
                申报
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
            <template #auditStatus="{ record }">
                <span style="color:gray" v-if="record.isSubmit==0">待提交</span>
                <span style="color:gray" v-if="record.auditStatus==0&&record.isSubmit==1">待审核</span>
                <span style="color:gold" v-if="record.auditStatus==1">审核中</span>
                <span style="color:green" v-if="record.auditStatus==2">通过</span>
                <span @click="modelShow = true" style="color:red" v-if="record.auditStatus==3">不通过</span>
                <a-modal  width="450px" footer="" style="margin-top:100px;" v-model:visible="modelShow" :closable="false">
                    不通过原因：<span style="color:red">{{record.annotation}}</span>
                </a-modal>
            </template>
            <template #oneClassification="{ record }">
				<dict-render :dict-obj="dictObjs['projectTypeManage1']" :text="record.oneClassification" v-if="record.oneClassification"></dict-render>
            </template>
            <template #projectName="{ record }">
                <a @click="onDetail(record)">{{record.projectName}}</a>
            </template>
                <template #action="{ record }">
                <div v-if="record.isSubmit!=1" class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                    <a @click="submit(record)">提交</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <a-modal width="450px" style="margin-top:100px;" v-model:visible="visible" :maskClosable="false" :closable="false" @ok="handleOk"
        @cancel="handleCancel">
        <div style="height:300px;display:flex;align-items: center;justify-content: center;">
        <a-form>
            <div>
                <pre style="color:red;margin-bottom:20px">注：认真选择该类型，以确保申报成功！</pre>
                <a-form-item label="填报年份" name="year">
                <YearPicker style="width: 100%" v-model:value="year" :format="dateFormat.DATE_YEAR"
                    :showTime="false" />
                </a-form-item>
                <a-form-item label="项目分类" name="oneClassification">
                <DictSelect style="display:inline-block" v-model:value="oneClassification" :dict-name="'projectTypeManage1'" placeholder="请选择" />
                </a-form-item>
            </div>
        </a-form>
        </div>
    </a-modal>
</template>

<script>
import { tableListMixin, dictMixin } from "@/mixins";
import { projectBasicsInfo } from "@/api/TechnologieprojekteApply";
import YearPicker from "@/components/form/datePicker/YearPicker";
import { dateFormat } from "@/config/variableConfig";
import DictSelect from "@/components/other/DictSelect";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    { title: "项目名称", dataIndex: "projectName", key: "projectName", width: '200px', slots: { customRender: "projectName" } },
    { title: "申报类型", dataIndex: "oneClassification", key: "oneClassification", slots: { customRender: "oneClassification" }},
    { title: "所属年度", dataIndex: "year", key: "year" },
    { title: "申报日期", dataIndex: "declareTime", key: "declareTime"},
    { title: "审核", dataIndex: "auditStatus", key: "auditStatus", slots: { customRender: "auditStatus" }},
    { title: "操作", fixed: 'right', dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
    name: "信息补充",
    mixins: [tableListMixin, dictMixin],
    components: {
        DictSelect,
        YearPicker
    },
    data() {
        return {
            modelShow: false,
            visible: false,
            dateFormat,
            year: null,
            oneClassification: null,
            dictNames: 'projectTypeManage1',
            columns,
            queryParam: {},
            listUrl: projectBasicsInfo.pageList,
            listKeyField: "id",
            deleteUrl: projectBasicsInfo.remove
        }
    },
    mounted() {
    },
    methods: {
        onAdd() {
            this.visible = true
        },
        handleOk() {
            if (!this.year || !this.oneClassification){
                this.$notification.warning({
                    message: '请选择项目分类和填报年份！',
                });
                return
            }
            this.postAction({
                url: projectBasicsInfo.isAllowAddData,
                params: {
                    oneClassification: this.oneClassification,
                    year: this.year
                 }
            }).then(res => {
                if(res.result=='true'){
                    this.$router.push({path: '/sys/TechnologieApplyModel', query: {type: res.processId,year: this.year, oneClassification: this.oneClassification}})
                }else{
                    this.visible = false;
                    this.$notification.warning({
                        message: '该项目分类暂未开通！',
                        style: {
                            fontWeight: '600',
                        },
                    });
                }
            })
        },
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible1 = true;
        },
        onEdit(record) {
            this.$router.push({path: '/sys/TechnologieApplyModel', query: {id: record.id, oneClassification:record.oneClassification}})
        },
        submit(record) {
            this.postAction({
                url: projectBasicsInfo.submit,
                params: {
                    id: record.id,
                    isSubmit: 1
                }
            }).then(() => {
                this.$message.success("提交成功！")
                this.loadData()
            })
        },
        onDetail(record) {
            this.getAction({
                url: projectBasicsInfo.detail,
                params: { id: record.id }
            }).then(res => {
                this.$router.push({path:'/sys/TechnologieApplyDetail',query: {processId: res.processId,projectId: res.id,classification: res.oneClassification,permissions: res.permissions}})
            })
        }
    }
}
</script>

<style scoped lang="less">
:deep(.ant-modal-body) {
    height: 100vh !important;
    max-height: 100vh !important;
}
</style>
